import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { type OrganizationMetadata } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { getOrganizationMetadata } from "../api/queries/getOrganizationMetadata";
import { type GetOrganizationMetadataQuery } from "../api/queries/getOrganizationMetadata.gql-generated";

export interface OrganizationMetadataResult {
    organizationMetadata: OrganizationMetadata | undefined | null;
}

export const useOrganizationMetadata = (
    organizationId: string,
    skip = false,
): ApolloResult<OrganizationMetadataResult> => {
    const { data, loading, error } = useQuery<GetOrganizationMetadataQuery>(getOrganizationMetadata, {
        variables: {
            organizationId,
        },
        skip,
    });

    return useMemo(() => {
        return {
            loading,
            error,
            organizationMetadata: data?.getOrganizationMetadata.organizationMetadata,
        };
    }, [loading, error, data?.getOrganizationMetadata.organizationMetadata]);
};
